import { bindDialog } from '@/utils/dialog';

// The dialog's list is fetched on first use (hover, focus or open) — every facility
// carries an inline SVG icon, which made property pages ~100 KB heavier.
function loadList(dialog) {
    const list = dialog.querySelector('[data-property-facilities-list]');
    if (!list || list.dataset.state === 'loading' || list.dataset.state === 'loaded') {
        return;
    }

    const status = list.querySelector('[data-property-facilities-status]');
    if (status) {
        status.textContent = 'Loading facilities…';
    }
    list.dataset.state = 'loading';
    list.setAttribute('aria-busy', 'true');
    fetch(list.dataset.propertyFacilitiesList, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            return response.text();
        })
        .then((html) => {
            list.innerHTML = html;
            list.dataset.state = 'loaded';
            list.setAttribute('aria-busy', 'false');
        })
        .catch(() => {
            if (status) {
                status.textContent = 'The facilities could not be loaded. Close this and try again.';
            }
            list.dataset.state = 'failed';
            list.setAttribute('aria-busy', 'false');
        });
}

document.querySelectorAll('[data-property-facilities-open]').forEach((trigger) => {
    const dialog = document.getElementById(trigger.dataset.propertyFacilitiesOpen);
    if (!dialog) {
        return;
    }

    const prefetch = () => loadList(dialog);
    trigger.addEventListener('pointerenter', prefetch, { once: true });
    trigger.addEventListener('focus', prefetch, { once: true });

    trigger.addEventListener('click', () => {
        loadList(dialog);
        dialog.showModal();
    });

    bindDialog(dialog, () => trigger.focus());
});
